module.exports = __webpack_public_path__ + "static/media/VA-logo@2x.547b8efe.png";